<div class="site-popup" [attr.data-tone]="tone">
  <h2 mat-dialog-title class="site-popup-title">{{ title }}</h2>
  <p class="site-popup-message">{{ descrizione }}</p>
  <div class="site-popup-actions">
    @if (obj_buttonAction) {
      <button class="site-popup-ghost" type="button" (click)="buttonClose()">{{ label_buttonClose }}</button>
      <button class="site-popup-action" type="button" (click)="buttonAction()">{{ label_buttonAction }}</button>
    } @else {
      <button class="site-popup-action" type="button" (click)="buttonClose()">{{ label_buttonClose }}</button>
    }
  </div>
</div>
